import { ensureNotNil } from '@studio/js-utils';
import type { Agent } from '@studio/models/agent';
import type { State } from './types.js';
import type { Device } from '#~/device/index.js';
import type { Room } from '#~/room/index.js';

/* eslint-disable jsdoc/require-jsdoc */
export class Slicer {
  #state: State;

  public constructor(state: State) {
    this.#state = state;
  }

  public agent(agentId: Agent['id']): Agent {
    return ensureNotNil(this.#state.agents[agentId]);
  }

  public device(roomId: Room['id'], deviceId: Device['id']): Device {
    return ensureNotNil(this.room(roomId).devices[deviceId]);
  }

  public room(roomId: Room['id']): Room {
    return ensureNotNil(this.#state.rooms[roomId]);
  }
}
